import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarClearance,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import StockFilterRange from '@/components/StockFilterRange';

function ClearanceFilter() {
  const dispatch = useTypedDispatch();
  const selectedClearance =
    useTypedSelector(getSelectedFilters).selectedParams.selectedClearance;

  const handleBlurClearance = (clearance: RangeType) => {
    dispatch(setCarClearance(clearance));
    dispatch(setPage(1));
  };

  return (
    <StockFilterRange
      label="Клиренс, мм"
      values={selectedClearance}
      onBlur={handleBlurClearance}
    />
  );
}

export default ClearanceFilter;
